export default __webpack_public_path__ + "static/media/cart.f2c9b638.svg";